import React, { PureComponent } from 'react'
import { func, shape } from 'prop-types'
import FormField from '@active/react-ui/FormField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import Button from '@active/react-ui/Button'
import { FormConsumer } from '@active/react-ui/Form'
import { withI18n } from '@active/react-utils/i18n'
import Form from '../common/InjectedForm'
import injectSigninWithContent from './components/SigninWithContent/injectSigninWithContent'
import './Signin.scss'
import I18nMessage from '../common/I18nMessage'
import CheckEmail from '../common/CheckEmail/CheckEmail'

class CUISignin extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    processes: shape({
      signIn: func.isRequired,
    }).isRequired,
    updateState: func.isRequired,
    services: shape({}).isRequired,
  }

  checkEmail

  constructor(props) {
    super(props)
    this.state = {
      initialValues: { email: '' },
    }
  }

  handleCheckAccount = values => {
    this.checkEmail(values.account, this.checkEmailCallback)
  }

  checkEmailCallback = ({ existAccount, newAccount, badDomain }) => {
    const { processes: { cuiSignIn: goBack, signIn }, updateState, ...rest } = this.props

    if (existAccount) {
      signIn({
        ...rest,
        goBack,
        username: existAccount,
        existingAccount: true,
        sentEmailGoBack: goBack,
      })
    } else if (newAccount) {
      updateState({ newAccount, isReagreeWaiverShow: true, openReagreeWaiverFrom: 'newAccountModel' })
    } else if (badDomain) {
      this.setState({
        isShowEmailBadListTip: true,
      })
    }
  }

  checkEmailTrigger = checkEmail => {
    this.checkEmail = checkEmail
  }

  render() {
    const { services, i18n } = this.props
    const { initialValues, isShowEmailBadListTip } = this.state

    return (
      <Form initialValues={initialValues} onSubmit={this.handleCheckAccount} className="clearfix">
        <FormGroup name="account" withoutLayout required className="check-email-form-group">
          <FormLabel htmlFor="account"><I18nMessage id="passport.common.label.emailAddress" /></FormLabel>
          <FormField
            as={CheckEmail}
            changeAble
            services={services}
            checkEmailTrigger={this.checkEmailTrigger}
            requiredError="passport.error.validation.invalidEmail"
            invalidError="passport.error.validation.invalidEmail"
            enableDomainCheck
            tipContent="passport.common.text.typoTip.content.withRegist"
            isShowWarning={isShowEmailBadListTip}
          />
        </FormGroup>
        <FormConsumer>
          {() => (
            <Button
              aria-label={i18n('passport.common.btn.next')}
              submit
              type="super"
              className="passport__cui__signin__submit-button"
            >
              <I18nMessage id="passport.common.btn.next" />
            </Button>
          )}
        </FormConsumer>
      </Form>
    )
  }
}

export default withI18n(injectSigninWithContent(CUISignin))
